export enum TotalizerTypeEnum {
  None = 0,
  Sum = 1,
  Min = 2 ,
  Max = 3,
  Average = 4,
  Count = 5
}
